import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fulfillmentBarcode: {
    description: 'Label for the barcode input in product details',
    defaultMessage: 'Enter Barcode',
    id: 'K5ky3Y',
  },
  fulfillmentBarcodeDescription: {
    description: 'Helper text for the barcode input in product details',
    defaultMessage:
      'A barcode is a unique identifier used in Fulfilled by ShipStation that helps track and manage products efficiently. You can add an alphanumeric barcode below to uniquely label and streamline the tracking of your inventory items.',
    id: 'PFBWwk',
  },
  fulfillmentBarcodesHeader: {
    description: 'Header for the barcodes section in product details',
    defaultMessage: 'Fulfillment Barcodes',
    id: 'PT43WN',
  },
  fulfillmentBarcodesInfoMessage: {
    description: 'Banner message for the barcodes section in product details',
    defaultMessage: 'Creating a barcode? Click the link to learn more about the rules and process.',
    id: '1fKI/C',
  },
  fulfillmentBarcodesWarningMessage: {
    description: 'Banner message for the barcodes section in product details',
    defaultMessage: 'Modifying barcodes for products already labeled in Fulfilled by ShipStation warehouses may cause delays.',
    id: 'TxlbfJ',
  },
  learnMore: {
    description: 'Text for the learn more link in product details',
    defaultMessage: 'Learn more',
    id: 'IVS8I2',
  },
});
